import { defineVuePlugin } from '#/vue-plugins'

import { client as intranetClient } from '@/shared/api/intranet/client.gen'

export default defineVuePlugin(() => {
  const origin = window.location.origin
  intranetClient.setConfig({
    baseUrl: `${origin}/api`,
  })
})
